/* AEVIA — interacciones del tema (sin dependencias). Se carga desde la sección aevia-header. */
(function () {
  if (window.__aeviaLoaded) return;
  window.__aeviaLoaded = true;

  /* ---------- Aparición al hacer scroll ---------- */
  var io = null;
  function revealAll() {
    document.querySelectorAll('.aev-fade-up:not(.aev-in)').forEach(function (el) { el.classList.add('aev-in'); });
  }
  function initFadeUp(root) {
    var items = (root || document).querySelectorAll('.aev-fade-up:not(.aev-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('aev-in'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Clicks delegados (menú, pestañas, galería, video, carrusel) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var navToggle = t.closest('[data-aev-nav-toggle]');
    if (navToggle) {
      var nav = document.querySelector('[data-aev-nav]');
      if (nav) {
        var open = nav.classList.toggle('aev-open');
        document.body.classList.toggle('aev-nav-open', open);
        navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }
    if (t.closest('[data-aev-nav] a')) {
      var n = document.querySelector('[data-aev-nav]');
      if (n) n.classList.remove('aev-open');
      document.body.classList.remove('aev-nav-open');
    }

    var tab = t.closest('[data-aev-tab]');
    if (tab) {
      var scope = tab.closest('[data-aev-tabs]') || document;
      var key = tab.getAttribute('data-aev-tab');
      scope.querySelectorAll('[data-aev-tab]').forEach(function (b) { b.classList.toggle('aev-active', b === tab); });
      scope.querySelectorAll('[data-aev-panel]').forEach(function (p) { p.classList.toggle('aev-active', p.getAttribute('data-aev-panel') === key); });
      return;
    }

    var thumb = t.closest('[data-aev-thumb]');
    if (thumb) {
      var gal = thumb.closest('[data-aev-gallery]');
      var idx = thumb.getAttribute('data-aev-thumb');
      gal.querySelectorAll('[data-aev-thumb]').forEach(function (b) { b.classList.toggle('aev-active', b === thumb); });
      gal.querySelectorAll('[data-aev-media]').forEach(function (m) { m.classList.toggle('aev-active', m.getAttribute('data-aev-media') === idx); });
      return;
    }

    var video = t.closest('[data-aev-video]');
    if (video && video.getAttribute('data-embed')) {
      var f = document.createElement('iframe');
      f.src = video.getAttribute('data-embed');
      f.allow = 'autoplay; fullscreen; picture-in-picture';
      f.allowFullscreen = true;
      f.title = video.getAttribute('aria-label') || 'Video';
      f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;z-index:3';
      video.appendChild(f);
      return;
    }

    var car = t.closest('[data-aev-carousel-prev],[data-aev-carousel-next]');
    if (car) {
      var wrap = car.closest('[data-aev-carousel]');
      var track = wrap && wrap.querySelector('[data-aev-carousel-track]');
      if (track) {
        var dir = car.hasAttribute('data-aev-carousel-next') ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-aev-video]')) {
      e.preventDefault();
      e.target.click();
    }
  });

  /* ---------- Hero: carrusel de banners ---------- */
  function initHeroes(root) {
    (root || document).querySelectorAll('[data-aev-hero]').forEach(function (hero) {
      if (hero.__aevHero) { hero.__aevHero.destroy(); }
      var slides = hero.querySelectorAll('[data-aev-slide]');
      if (slides.length < 2) return;
      var dots = hero.querySelectorAll('[data-aev-hero-dot]');
      var pauseBtn = hero.querySelector('[data-aev-hero-pause]');
      var idx = 0, timer = null, userPaused = false, hovering = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = hero.getAttribute('data-autoplay') === 'true' && !reduce;
      var ms = Math.max(3, parseInt(hero.getAttribute('data-interval'), 10) || 6) * 1000;

      function show(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          s.classList.toggle('aev-active', i === idx);
          s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
        });
        dots.forEach(function (d, i) { d.classList.toggle('aev-active', i === idx); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (autoplay && !userPaused && !hovering && !document.hidden) timer = setInterval(function () { show(idx + 1); }, ms);
      }
      function onClick(e) {
        var b = e.target.closest('button');
        if (!b || !hero.contains(b)) return;
        if (b.hasAttribute('data-aev-hero-next')) { show(idx + 1); start(); }
        else if (b.hasAttribute('data-aev-hero-prev')) { show(idx - 1); start(); }
        else if (b.hasAttribute('data-aev-hero-dot')) { show(parseInt(b.getAttribute('data-aev-hero-dot'), 10)); start(); }
        else if (b.hasAttribute('data-aev-hero-pause')) {
          userPaused = !userPaused;
          b.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
          start();
        }
      }
      function onEnter() { hovering = true; stop(); }
      function onLeave() { hovering = false; start(); }
      var sx = null;
      function onTouchStart(e) { sx = e.touches[0].clientX; }
      function onTouchEnd(e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 50) { show(idx + (dx < 0 ? 1 : -1)); start(); }
      }
      function onVis() { if (document.hidden) stop(); else start(); }
      function onBlockSelect(e) {
        var i = Array.prototype.indexOf.call(slides, e.target);
        if (i > -1) { stop(); show(i); }
      }
      hero.addEventListener('click', onClick);
      hero.addEventListener('mouseenter', onEnter);
      hero.addEventListener('mouseleave', onLeave);
      hero.addEventListener('focusin', onEnter);
      hero.addEventListener('focusout', onLeave);
      hero.addEventListener('touchstart', onTouchStart, { passive: true });
      hero.addEventListener('touchend', onTouchEnd, { passive: true });
      hero.addEventListener('shopify:block:select', onBlockSelect);
      hero.addEventListener('shopify:block:deselect', start);
      document.addEventListener('visibilitychange', onVis);
      hero.__aevHero = {
        destroy: function () {
          stop();
          hero.removeEventListener('click', onClick);
          hero.removeEventListener('mouseenter', onEnter);
          hero.removeEventListener('mouseleave', onLeave);
          hero.removeEventListener('focusin', onEnter);
          hero.removeEventListener('focusout', onLeave);
          hero.removeEventListener('touchstart', onTouchStart);
          hero.removeEventListener('touchend', onTouchEnd);
          hero.removeEventListener('shopify:block:select', onBlockSelect);
          hero.removeEventListener('shopify:block:deselect', start);
          document.removeEventListener('visibilitychange', onVis);
        }
      };
      show(0);
      start();
    });
  }

  /* ---------- Marcas: flechas del carrusel de logos (se ocultan en los extremos / si todo cabe) ---------- */
  function initBrandBars(root) {
    (root || document).querySelectorAll('[data-aev-brandbar]').forEach(function (bar) {
      var track = bar.querySelector('[data-aev-carousel-track]');
      if (!track) return;
      var dotsBox = null;
      if (bar.hasAttribute('data-aev-dots')) {
        dotsBox = bar.querySelector('.aev-dots');
        if (!dotsBox) {
          dotsBox = document.createElement('div');
          dotsBox.className = 'aev-dots';
          Array.prototype.forEach.call(track.children, function (item, i) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'aev-dot';
            d.setAttribute('aria-label', String(i + 1));
            d.addEventListener('click', function () { track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
            dotsBox.appendChild(d);
          });
          bar.appendChild(dotsBox);
        }
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        bar.classList.toggle('aev-at-start', track.scrollLeft <= 2);
        bar.classList.toggle('aev-at-end', max <= 2 || track.scrollLeft >= max - 2);
        if (dotsBox && track.children.length > 1) {
          var step = track.children[1].offsetLeft - track.children[0].offsetLeft;
          var idx = max > 2 && track.scrollLeft >= max - 2 ? track.children.length - 1 : Math.round(track.scrollLeft / (step || 1));
          Array.prototype.forEach.call(dotsBox.children, function (d, i) { d.classList.toggle('aev-active', i === idx); });
        }
      }
      if (!bar.__aevBar) {
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        bar.__aevBar = true;
      }
      update();
      setTimeout(update, 600); // tras cargar las imágenes
    });
  }

  function boot() {
    initFadeUp(document);
    initHeroes(document);
    initBrandBars(document);
    setTimeout(revealAll, 3000); // red de seguridad: nunca dejar contenido oculto
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // editor de temas de Shopify: re-inicializar cuando se recarga una sección
  document.addEventListener('shopify:section:load', function (e) { initFadeUp(e.target); initHeroes(e.target); initBrandBars(e.target); setTimeout(revealAll, 400); });
})();
